<style scoped>
.pager-btn {
    @apply mx-1 w-4 border rounded font-bold border-gray-100 border-dotted;
}
.pager-btn.current {
    @apply text-secondary;
}
.pager-btn:focus {
    @apply outline-none;
}

@screen sm {
    .pager-btn {
        @apply w-6;
    }
}
</style>

<template>
    <div class="flex flex-row text-xs">
        <button
            class="flex items-center  focus:outline-none"
            @click="setPage(page + 1)"
        >
            <div class="icon">
                <chevronLeft />
            </div>
        </button>
        <template v-if="pages[0] !== 1">
            <button
                class="pager-btn"
                :class="{ current: 1 === page }"
                @click="setPage(1)"
            >
                1
            </button>
            <div class="px-1" v-if="pages[0] !== 2">&hellip;</div>
        </template>

        <button
            class="pager-btn"
            v-for="p in pages"
            :key="p"
            :class="{ current: p === page }"
            @click="setPage(p)"
        >
            {{ p }}
        </button>

        <template v-if="pages[pages.length - 1] !== numOfPage">
            <div class="px-1" v-if="pages[pages.length - 1] !== numOfPage - 1">
                &hellip;
            </div>
            <button
                class="pager-btn"
                :class="{ current: numOfPage === page }"
                @click="setPage(numOfPage)"
            >
                {{ numOfPage }}
            </button>
        </template>
        <button
            class="flex items-center focus:outline-none"
            @click="setPage(page + 1)"
        >
            <div class="icon">
                <chevronRight />
            </div>
        </button>
    </div>
</template>

<script>
import chevronLeft from '../assets/svg/chevron_left.svg';
import chevronRight from '../assets/svg/chevron_right.svg';

const makeArray = (from, to) =>
    [...Array(to - from + 1).keys()].map(i => i + from);

const bound = (n, min, max) => Math.max(min, Math.min(n, max));

export default {
    components: {
        chevronLeft,
        chevronRight
    },
    props: {
        page: { type: Number, required: true },
        recordsPerPage: { type: Number, required: true },
        totalRecords: { type: Number, required: true },
        offset: { type: Number, default: 2 }
    },
    computed: {
        numOfPage() {
            return Math.ceil(this.totalRecords / this.recordsPerPage);
        },
        pages() {
            if (this.numOfPage <= this.offset * 2 + 1) {
                return makeArray(1, this.numOfPage);
            }

            const focus = bound(
                this.page,
                this.offset + 1,
                this.numOfPage - this.offset
            );
            return makeArray(focus - this.offset, focus + this.offset);
        }
    },
    methods: {
        setPage(page) {
            if (page < 1 || page > this.numOfPage) {
                return;
            }
            this.$emit('setPage', page);
        }
    }
};
</script>
